import {
	ADD_QUICK_CREATE
} from '../constact'


const defaultState = {
	quickCreate: {}
}

export function addQuickcreate(data) {
	return {
		type: ADD_QUICK_CREATE,
		data
	}
}
const quickGenerate = (state = defaultState, action) => {
	if(action.type === ADD_QUICK_CREATE) {
		const newState = JSON.parse(JSON.stringify(state))
		const { id, value } = action.data
		newState.quickCreate = {}
		newState.quickCreate[id] = value
		return newState

	}
	return state
}
export default quickGenerate